import { Link } from 'react-router-dom';

interface AuthLayoutProps {
  children: React.ReactNode;
}

export default function AuthLayout({ children }: AuthLayoutProps) {
  return (
    <div className="from-background to-muted flex min-h-screen flex-col items-center justify-center bg-gradient-to-br p-4">
      {/* Logo and Brand */}
      <div className="mb-8 text-center">
        <Link to="/" className="mb-2 flex items-center justify-center gap-2">
          <div className="bg-primary flex h-10 w-10 items-center justify-center rounded-lg">
            <span className="text-primary-foreground text-xl font-bold">T</span>
          </div>
          <span className="text-2xl font-bold">Tyashin</span>
        </Link>
        <p className="text-muted-foreground text-sm">The AI growth &amp; commerce OS</p>
      </div>

      {/* Auth Card Container */}
      <div className="w-full max-w-md">
        <div className="bg-card rounded-xl border p-8 shadow-lg">{children}</div>
      </div>

      {/* Footer */}
      <div className="text-muted-foreground mt-8 text-center text-sm">
        <p>© {new Date().getFullYear()} Tyashin · Aapastech Pvt Ltd. All rights reserved.</p>
      </div>
    </div>
  );
}
